<div
  class="m-spacer"
  [style]="'--mobile:' + mobile + 'px' + ';' + '--desktop:' + desktop + 'px'"
  aria-hidden="true"
></div>
